<template>
  <div v-if="pageSensor != null && isLoginUserItemReadable(this.pageSensor)">
    <sensorTabs :current="'download'" :pageSensor="pageSensor"  :pageUser="pageUser">

      <b-button type="button" variant="warning" class="float-right tabButton" size="sm" v-if="showUpdateButton">
        <b-spinner small type="grow" class="mr-0"></b-spinner>
        새 데이터 반영중
      </b-button>

    </sensorTabs>

    <div class="m-0 mt-4 mr-2" :class="{ 'owner': this.isLoginUserPageUser, 'notOwner': !this.isLoginUserPageUser }" v-if="this.pageSensor">
      <div v-if="isLoginUserPageUser">
        <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger" v-if="this.pageSensor.disabled == 1">
          정지 중이므로 기기의 정보를 변경할 수 없습니다.
        </b-alert>
      </div>
      <div class="mt-3 mr-2 stepBlock">
        <p class="gothic">
        센서 데이터는 1,000개 단위의 묶음으로 저장합니다. 묶음 0이 가장 오래된 데이터입니다. 아래 목록에서 범위를 선택하여 <span v-if="isLoginUserItemWritable(this.pageSensor)">데이터를 삭제하거나</span> JSON, CSV 형식의 텍스트 파일로 다운로드 할 수 있습니다.
        </p>
      </div>
      <div class="controlBlock" v-if="this.selected.length != 0">
        <span>
          선택한
          <b>{{this.selected.length}}</b>개의 묶음
          (전체 데이터 줄 수: <b>{{this.selectedTotalCount}}</b> 개)를
        </span>
        <b-button size="sm" variant="danger" @click="openDeleteBooks()" v-b-tooltip.hover title="선택한 묶음의 데이터를 삭제합니다." :disabled="this.pageSensor.disabled == true || this.pageDevice.disabled == true" v-if="isLoginUserItemWritable(this.pageSensor)">삭제</b-button><span v-if="isLoginUserItemWritable(this.pageSensor)">,</span>
        <b-button size="sm" variant="primary" @click="openDownloadCSV()" v-b-tooltip.hover title="선택한 묶음의 데이터를 CSV(텍스트) 형식으로 다운로드합니다.">CSV(텍스트) 다운로드</b-button>,
        <b-button size="sm" variant="primary" @click="openDownloadJSON()" v-b-tooltip.hover title="선택한 묶음의 데이터를 JSON 형식으로 다운로드합니다.">JSON 다운로드</b-button> 합니다.
      </div>
      <div class="stepBlock gothic">
        <b-table v-touch:swipe.stop striped bordered head-variant="dark" hover :fields="gridFields" :items="bookList" selectable select-mode="range" selectedVariant="primary" primary-key="id" @row-selected="applyProp" class="bookGrid" size="sm">
          <template v-slot:cell(selected)="data">
            <span v-if="data.rowSelected">✔</span>
          </template>
        </b-table>
      </div>

      <div class="mt-2 mb-2 text-left"  v-if="isLoginUserPageUser">
        <b-button variant="outline-dark" v-b-modal.resetSensor size="sm">
          센서 초기화
        </b-button>
      </div>

      <b-modal v-touch:swipe.stop size="lg" id="resetSensor" tabindex="-1" title="센서 초기화" static @show="modalShowFocus" data-nextfocus="closeResetSensor" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
        <p class="gothic">
          센서의 전체 데이터를 삭제하고 센서 정보를 초기화 합니다.
          <span style="color:red; font-weight: bold">센서를 초기화한 후에는 취소하거나
            데이터를 복구할 수 없습니다</span>. 데이터가 필요하면 데이터를 다운로드 한 다음에 센서 초기화를 한 후에 다운로드한 데이터를 다시 업로드 하시기 바랍니다.
        </p>
        <template slot="modal-footer">
          <b-button variant="outline-secondary" size="sm" @click="resetSensor" :disabled="!this.pageBinded" v-b-tooltip.hover title="센서를 초기화합니다. 초기화 후에는 삭제할 수 없습니다.">
            <b-spinner small type="grow" class="mr-1" v-if="resetSensorSpinner"></b-spinner>
            초기화 하기
          </b-button>
          <b-button variant="primary" id="closeResetSensor" @click="closeResetSensor" v-b-tooltip.hover title="취소하기 현재 창을 닫습니다.">
            취소하기
          </b-button>
        </template>
      </b-modal>


      <b-modal v-touch:swipe.stop size="lg" id="deleteBooks" tabindex="-1" title="데이터 삭제하기" static @show="modalShowFocus" data-nextfocus="closeDeleteBooks" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
        <p class="gothic">
          {{this.selectedListString}}번 묶음, 총 <b>{{this.selected.length}}</b>개의 묶음
          (전체 데이터 줄 수: <b>{{this.selectedTotalCount}}</b> 개)를 삭제합니다.
          <span style="color:red; font-weight: bold">데이터를 삭제한 후에는 취소하거나
            복구할 수 없습니다</span>.
        </p>
        <template slot="modal-footer">
          <b-button variant="outline-secondary" size="sm" @click="deleteBooks" :disabled="!this.pageBinded" v-b-tooltip.hover title="데이터를 삭제합니다. 삭제 후에는 복구할 수 없습니다.">
            <b-spinner small type="grow" class="mr-1" v-if="deleteBooksSpinner"></b-spinner>
            삭제하기
          </b-button>
          <b-button variant="primary" id="closeDeleteBooks" @click="closeDeleteBooks" v-b-tooltip.hover title="취소하고 현재 창을 닫습니다.">
            삭제 취소하기
          </b-button>
        </template>
      </b-modal>

      <b-modal v-touch:swipe.stop size="lg" id="downloadCSV" tabindex="-1" title="CSV 파일 다운로드" static @show="modalShowFocus" data-nextfocus="closeDownloadCSV" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
        <p class="gothic">
          {{this.selectedListString}} 묶음, 총 <b>{{this.selected.length}}</b>개의 묶음
          (전체 데이터 줄 수: <b>{{this.selectedTotalCount}}</b> 개)를 CSV 형식(값이 쉼표로
          구분된 텍스트 파일)으로 다운로드 합니다.
        </p>
        <b-form @submit.stop.prevent class="was-validated mr-3 ml-2">
          <b-input-group class="mt-2">
            <b-input-group-text size="sm" slot="prepend" class="leftCellTitle fontSizeDot9 p-dot1 pl-2" style="width : 100px;">
              <label for="csvFileName" style="margin-bottom : 0rem">파일 이름</label>
            </b-input-group-text>
            <b-form-input v-touch:swipe.stop id="csvFileName" v-model="csvFileName" size="sm" required/>
            <b-form-select slot="append" size="sm" id="csvExtension" required v-model="csvExtension" :options="[
              {value: 'csv', text: '.csv'},
              {value: 'txt', text: '.txt'}
            ]">
            </b-form-select>
          </b-input-group>

          <b-input-group class="mt-2">
            <b-input-group-text slot="prepend" class="leftCellTitle fontSizeDot9 p-dot1 pl-2" style="width : 100px;">
              <label for="csvIncludeHead" style="margin-bottom : 0rem">제목 줄</label>
            </b-input-group-text>
            <b-form-select size="sm" id="csvIncludeHead" required v-model="csvIncludeHead" :options="[
              {value: false, text: '포함 안함'},
              {value: true, text: '포함'}
            ]">
            </b-form-select>
          </b-input-group>
          <b-input-group class="mt-2">
            <b-input-group-text slot="prepend" class="leftCellTitle fontSizeDot9 p-dot1 pl-2" style="width : 100px;">
              <label for="csvDateTimeFormat" style="margin-bottom : 0rem">날짜 형식</label>
            </b-input-group-text>
            <b-form-select size="sm" id="csvDateTimeFormat" required v-model="csvDateTimeFormat" :options="[
            {value: 'excel', text: '엑셀 맞춤형: 1999-12-31 23:59:59'},
              {value: 'epoch', text: '숫자(유닉스 시간): 1970년 1월 1일 경과 시간(초)'},
              {value: 'dtstr', text: '문자열(ISO8601): 1999-12-31T23:59:59+09:00'},
            ]">
            </b-form-select>
          </b-input-group>
          <b-input-group class="mt-2">
            <b-input-group-text slot="prepend" class="leftCellTitle fontSizeDot9 p-dot1 pl-2" style="width : 100px;">
              <label for="csvValueSeperator" style="margin-bottom : 0rem">값 구분자</label>
            </b-input-group-text>
            <b-form-input size="sm" v-touch:swipe.stop id="csvValueSeperator" v-model="csvValueSeperator" required/>
          </b-input-group>
          <b-input-group class="mt-2" size="sm">
            <b-input-group-text slot="prepend" class="leftCellTitle fontSizeDot9 p-dot1 pl-2" style="width : 100px;">
              <label for="csvRowSeperator" style="margin-bottom : 0rem">줄 구분자</label>
            </b-input-group-text>
            <b-form-input size="sm" v-touch:swipe.stop id="csvRowSeperator" v-model="csvRowSeperator" required/>
          </b-input-group>
        </b-form>
        <template slot="modal-footer">
          <b-button v-if="this.csvDownloadURL != null" size="sm" variant="danger" :href="this.csvDownloadURL" :download="csvFileName + '.' + csvExtension" v-b-tooltip.hover title="만든 CSV 파일을 다운로드합니다.">
            CSV 파일 다운로드
          </b-button>
          <b-button v-else variant="outline-secondary" size="sm" @click="downloadCSV" :disabled="!this.pageBinded" v-b-tooltip.hover title="CSV 파일을 만듭니다. 만든 후에 다운로드 해야합니다.">
            CSV 파일 만들기
          </b-button>
          <b-button variant="primary" id="closeDownloadCSV" @click="closeDownloadCSV" v-b-tooltip.hover title="취소하고 현재 창을 닫습니다.">
            취소하기
          </b-button>
        </template>
      </b-modal>


      <b-modal v-touch:swipe.stop size="lg" id="downloadJSON" tabindex="-1" title="JSON 파일 다운로드" static @show="modalShowFocus" data-nextfocus="closeDownloadJSON" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
        <p class="gothic">
          {{this.selectedListString}} 묶음, 총 <b>{{this.selected.length}}</b>개의 묶음
          (전체 데이터 줄 수: <b>{{this.selectedTotalCount}}</b> 개)를 JSON(자바스크립트 개체 표기법)으로 다운로드 합니다.
        </p>
        <b-form @submit.stop.prevent class="was-validated mr-2 ml-3">
          <b-input-group class="mt-2" size="sm">
            <b-input-group-text slot="prepend" class="leftCellTitle fontSizeDot9 p-dot1 pl-2" style="width : 100px;">
              <label for="jsonFileName" style="margin-bottom : 0rem">파일 이름</label>
            </b-input-group-text>
            <b-form-input  v-touch:swipe.stop id="jsonFileName" v-model="jsonFileName" size="sm" required/>
            <b-input-group-text class="fontSizeDot9 p-dot1 pl-1 pr-3"><b>.json</b></b-input-group-text>
          </b-input-group>

          <b-input-group class="mt-2" size="sm">
            <b-input-group-text slot="prepend" class="leftCellTitle fontSizeDot9 p-dot1 pl-2" style="width : 100px;">
              <label for="hasJsonTabAndNewLine" style="margin-bottom : 0rem">공백 형식</label>
            </b-input-group-text>
            <b-form-select id="hasJsonTabAndNewLine" required v-model="hasJsonTabAndNewLine" :options="[
              { value: false, text: '탭과 줄바꿈 없음' },
              { value: true, text: '탭과 줄바꿈 있음' }
            ]">
            </b-form-select>
          </b-input-group>

        </b-form>
        <template slot="modal-footer">
          <b-button v-if="this.jsonDownloadURL != null" size="sm" variant="danger" :href="jsonDownloadURL" :download="jsonFileName + '.json'" v-b-tooltip.hover title="만든 JSON 파일을 다운로드합니다.">
            JSON 파일 다운로드
          </b-button>
          <b-button v-else variant="outline-secondary" size="sm" @click="downloadJSON" :disabled="!this.pageBinded" v-b-tooltip.hover title="CSV 파일을 만듭니다. 만든 후에 다운로드해야 합니다.">
            JSON 파일 만들기
          </b-button>
          <b-button variant="primary" id="closeDownloadJSON" @click="closeDownloadJSON" v-b-tooltip.hover title="취소하고 현재 창을 닫습니다.">
            취소하기
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"

import sensorTabs from "@/components/sensor/sensorTabs.vue"

export default {
  name: "sensorUpload",
  mixins: [uiUtil, user],
  props: {
    pageUser: {
      type: Object,
      default: null
    },
    pageDevice: {
      type: Object,
      default: null
    },
    pageSensor: {
      type: Object,
      default: null
    },
    pageSensorHistory: {
      type: Object,
      default: null
    },
    pageBinded: {
      type: Boolean,
      default: false
    },
  },
  components: {
    sensorTabs,
  },
  data: function() {
    return {

      gridUpdating: false,
      showUpdateButton: false,
      deleteBooksSpinner: false,
      resetSensorSpinner: false,

      lastBook: null,
      lastIndex: null,
      lastValuesModified: null,

      oldBook: null,
      oldIndex: null,

      jsonFileName: "",
      hasJsonTabAndNewLine: true,
      csvDownloadURL: null,
      jsonDownloadURL: null,

      csvFileName: "",
      csvExtension: "csv",
      csvValueSeperator: ",",
      csvRowSeperator: "\\n",
      csvIncludeHead: true,
      csvDateTimeFormat: "epoch",
      gridFields: [
        {
          key: "selected",
          label: "",
          tdClass: "selectTd",
        },
        {
          key: "id",
          label: "묶음",
          sortable: false,
          tdClass: "idTd",
        },
        {
          key: "from",
          label: "from",
          sortable: false,
          formatter: value => {
            return this.dateToString(value.toDate())
          },
          tdClass: "timeTd",
        },
        {
          key: "to",
          label: "to",
          sortable: false,
          formatter: value => {
            return this.dateToString(value.toDate())
          },
          tdClass: "timeTd",
        },
        {
          key: "count",
          label: "줄 수",
          sortable: false,
          tdClass: "numberTd",
          formatter: value => {
            return value.toLocaleString()
          }
        }
      ],
      selected: [],
    }
  },
  mounted: function() {
    this.lastBook = this.pageSensor.lastBook
    this.lastIndex = this.pageSensor.lastIndex
    this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null: this.pageSensor.lastValuesModified.toDate()
    // if(this.pageDevice.active) {
    //   this.makeToast("info", "알림", "데이터를 삭제하려면 업로드가 꺼짐 상태여야 합니다.");
    // }
  },
  updated: function() {
    if(this.pageDevice.active) {

      // 데이터수는 같은 데 데이터가 달라졌다.
      if(this.rowCount == this.rowCountPageSensor) {
        if(!this.gridUpdating) {
          if(this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime()) {

            this.$set(this.$parent.$parent, "pageSensorHistory", {});

            this.lastBook = this.pageSensor.lastBook
            this.lastIndex = this.pageSensor.lastIndex
            this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()

          }
        }
      }
      // 1줄 늘어났다.
      else if((this.rowCountPageSensor - this.rowCount) == 1) {
        if(!this.gridUpdating) {

          this.showUpdateButton = true

          if(this.pageSensor.lastIndex == 0) {
            this.pageSensorHistory[this.pageSensor.lastBook+ ""] = {
              dirty: false,
              data: {}
            }
          }

          if(typeof(this.pageSensorHistory[this.pageSensor.lastBook + ""]) != "undefined") {
            this.pageSensorHistory[this.pageSensor.lastBook + ""].data[this.pageSensor.lastIndex+""] = this.pageSensor.lastValues
          }

          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()

          window.setTimeout(()=>{
            this.showUpdateButton = false
          },1500)
        }
      }
      // 데이터가 줄어들었다.
      else if((this.rowCountPageSensor - this.rowCount) < 0) {
        if(!this.gridUpdating) {

          this.$set(this.$parent.$parent, "pageSensorHistory", {});

          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()

        }
      }
      // 1줄 이상 늘어났다.
      else if((this.rowCountPageSensor - this.rowCount) > 1) {
        if(!this.gridUpdating) {

          this.$set(this.$parent.$parent, "pageSensorHistory", {});

          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()
        }
      }
    }
    else {
      // if((this.lastValuesModified == null && this.pageSensor.lastValuesModified != null && !this.gridUpdating) ||(this.lastValuesModified != null && this.pageSensor.lastValuesModified == null && !this.gridUpdating) ||(this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime() && !this.gridUpdating)) {
      if(!this.gridUpdating) {
        if(
            (this.lastValuesModified == null && this.pageSensor.lastValuesModified != null)||
            (this.lastValuesModified != null && this.pageSensor.lastValuesModified == null)||
            (this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime())
        ) {
          this.$parent.$parent.makeToast("danger", "데이터 동기화", "데이터가 수정되어 캐시된 데이터를 초기화합니다.", {
            "autoHideDelay": 5000
          })

          this.$set(this.$parent.$parent, "pageSensorHistory", {});

          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()

        }
      }
    }
  },
  methods: {
    closeDownloadCSV: function() {
      if(this.csvDownloadURL != null) {
        URL.revokeObjectURL(this.csvDownloadURL)
        this.csvDownloadURL = null
      }
      this.hideModal('downloadCSV')
    },
    openDownloadCSV: function() {
      if(this.csvDownloadURL != null) {
        URL.revokeObjectURL(this.csvDownloadURL)
        this.csvDownloadURL = null
      }
      this.csvFileName = this.pageSensor.name + "_csv_" + this.dateToString(new Date(), "_", "_", "_")
      this.showModal('downloadCSV')
    },
    downloadCSV: function() {
      this.downloadValues('csv')
    },
    downloadJSON: function() {
      this.downloadValues('json')
    },

    downloadValues: function(type="json") {
      var toRequest = []
      this.selectedList.forEach((item, bookIndex, array) => {
        if(typeof(this.pageSensorHistory[item]) == "undefined") {
          toRequest.push(item)
        }
        else if(this.pageSensorHistory[item].dirty) {
          toRequest.push(item)
        }
      })
      if(toRequest.length !=0) {
        var successCount = 0
        toRequest.forEach(item => {
          db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item+ "")
          .get()
          .then(book => {
            if(book.exists) {
              this.pageSensorHistory[item+""] = {
                dirty: false,
                data: book.data()
              }
              if(++successCount == toRequest.length) {
                if(type == "json") this.makeJSON()
                else this.makeCSV()
              }
            }
            else {
              if(item == 0) {
                this.makeToast("info", "데이터 조회중", "데이터가 없습니다.")
              }
              else {
                this.makeToast("info", "데이터 조회중", item + "번 묶음 데이터가 없습니다.")
              }
            }
          })
          .catch(error => {
            this.makeToast("danger", "데이터 조회중", "데이터 조회 중 에러가 발생했습니다. 에러 내용: " + error)
          })
        })
      }
      else {
        if(type == "json") this.makeJSON()
        else this.makeCSV()
      }
    },
    makeJSON: function() {
      var result = []
      this.selectedList.forEach((book, bookIndex, array) => {
        if(typeof(this.pageSensorHistory[book]) != "undefined" && this.pageSensorHistory[book].dirty == false) {
          for(var item in this.pageSensorHistory[book].data) {
            if(item != "owner") {
              var toAdd = {}
              toAdd.dt = this.pageSensorHistory[book].data[item].t.seconds
              this.pageSensor.values.forEach((value,index)=>{
                toAdd[value.name] = this.pageSensorHistory[book].data[item].v[index]
              })
              result.push(toAdd)
            }
          }
        }
      })

      if(this.hasJsonTabAndNewLine) {
        var resultStr = JSON.stringify(result, null, "\t");
      }
      else  {
        var resultStr = JSON.stringify(result);
      }
      var blob = new Blob([resultStr], {
        type: "text/plain;charset=utf-8"
      })
      if(this.jsonDownloadURL != null) {
        URL.revokeObjectURL(this.jsonDownloadURL)
        this.jsonDownloadURL = null
      }
      this.jsonDownloadURL = URL.createObjectURL(blob)
    },
    makeCSV: function() {
      var result = []
      this.selectedList.forEach((book, bookIndex, array) => {
        if(typeof(this.pageSensorHistory[book]) != "undefined" && this.pageSensorHistory[book].dirty == false) {
          for(var item in this.pageSensorHistory[book].data) {
            if(item != "owner") {
              var toAdd = []
              if(this.csvDateTimeFormat == "epoch") {
                toAdd.push(Math.floor(this.pageSensorHistory[book].data[item].t.toDate().getTime()/1000) + "")
              }
              else if(this.csvDateTimeFormat == "dtstr") {
                toAdd.push(this.toISOString(this.pageSensorHistory[book].data[item].t.toDate()))
              }
              else {
                toAdd.push(this.dateToString(this.pageSensorHistory[book].data[item].t.toDate(), "-", " ", ":"))
              }
              this.pageSensor.values.forEach((value,index)=>{
                toAdd.push(this.pageSensorHistory[book].data[item].v[index])
              })
              result.push(toAdd)
            }
          }
        }
      })
      var rowSeperator = this.csvRowSeperator.replace("\\n", "\r\n").replace("\\t", "\t")
      var valueSeperator = this.csvValueSeperator.replace("\\n", "\r\n").replace("\\t", "\t")
      var resultStr = ""
      if(this.csvIncludeHead) {
        resultStr += "datetime" + valueSeperator
        this.pageSensor.values.forEach((value,index) => {
          resultStr += (index == (this.pageSensor.values.length-1))? value.name : value.name + valueSeperator
        })
        resultStr += rowSeperator
      }
      result.forEach((row, rowIndex) => {
          row.forEach((value, index) => {
            resultStr += (index == (row.length-1))? value+"": value + valueSeperator
          })
          if(rowIndex != result.length-1) resultStr += rowSeperator
      })


      var blob = new Blob([resultStr], {
        type: "text/plain;charset=utf-8"
      })

      if(this.csvDownloadURL != null) {
        URL.revokeObjectURL(this.csvDownloadURL)
        this.csvDownloadURL = null
      }
      this.csvDownloadURL = URL.createObjectURL(blob)
    },
    closeDownloadJSON: function() {
      if(this.jsonDownloadURL != null) {
        URL.revokeObjectURL(this.jsonDownloadURL)
        this.jsonDownloadURL = null
      }
      this.hideModal('downloadJSON')
    },
    openDownloadJSON: function() {
      if(this.jsonDownloadURL != null) {
        URL.revokeObjectURL(this.jsonDownloadURL)
        this.jsonDownloadURL = null
      }
      this.jsonFileName = this.pageSensor.name + "_json_" + this.dateToString(new Date(), "_", "_", "_")
      this.showModal('downloadJSON')
    },

    resetSensor: function() {

      let oldActive = this.pageDevice.active;
      if(oldActive) {
        db.collection("devices").doc(this.pageDevice.id).update({
          active: false
        })
      }

      db.collection("sensors").doc(this.pageSensor.id).collection("history")
      .get()
      .then(result => {

        let deleted = 0;
        this.gridUpdating = true;

        if(result.docs.length != 0) this.resetSensorSpinner = true;

        result.docs.forEach(doc => {
            db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(doc.id).delete()
            .then(() => {
              deleted++;
              if(deleted == result.docs.length) {
                this.resetSensorSpinner = false;
                this.closeResetSensor();
                this.makeToast("info", "저장 데이터 삭제 완료", "저장된 데이터를 모두 삭제했습니다.", {
                  "autoHideDelay": 10000
                });


              }
            });
        });

        db.collection("sensors").doc(this.pageSensor.id)
        .set({
          bookInfo: {},
          lastValues: null,
          lastValuesModified: null,
          lastBook: 0,
          lastIndex: -1,
        },{ merge: true })
        .then(() => {
          this.makeToast("info", "초기화 완료", "센서를 초기화 했습니다. 저장된 데이터가 있고 저장된 데이터 삭제가 완료된 갱우에는 따로 [저장 데이터 삭제 완료] 알림이 표시됩니다. 저장된 데이터가 100만 개 이상으로 아주 많은 경우에는 초기화를 여러 번 해야할 수도 있습니다. ", {
            "autoHideDelay": 10000
          });
          if(oldActive) {
            db.collection("devices").doc(this.pageDevice.id).update({
              active: true
            })
          }
          this.gridUpdating = false;
        });

      });
    },

    closeResetSensor: function() {
      this.hideModal('resetSensor');
    },

    deleteBooks: function() {

      if(this.selectedList.length != 0) {

        let oldActive = this.pageDevice.active;
        if(oldActive) {
          db.collection("devices").doc(this.pageDevice.id).update({
            active: false
          })
        }


        this.deleteBooksSpinner = true;

        var startBook = this.selectedList[0]
        var newBookIndex = startBook
        var toRequest = []
        var actionList = []
        var lastBookFrom = null
        var lastBookTo = null
        var endBook = this.pageSensor.lastBook
        var deleteOnly = true


        for(var i=startBook;i<=endBook;i++) {
          if(typeof(this.selectedListObject[i]) != "undefined") {
            actionList.push({
              action: "delete",
              id: i+"",
            })
          }
          else {
            console.log(this.pageSensorHistory);
            if(typeof(this.pageSensorHistory[i]) == "undefined" || this.pageSensorHistory[i].dirty == true) {
              toRequest.push(i)
            }
            deleteOnly = false
            actionList.push({
              action: "rename",
              from: i +"",
              to: newBookIndex + ""
            })
            newBookIndex++
          }
        }
        var successCount = 0
        if(deleteOnly) {
          if(startBook != 0) {
            toRequest.push(startBook-1)
          }
        }

        // console.log(startBook + " " + endBook)
        // console.log(toRequest)

        if(toRequest.length != 0) {
          toRequest.forEach((item, index, array) => {
            db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item+ "")
            .get()
            .then(book => {
              if(book.exists) {

                this.pageSensorHistory[item+""] = {
                  dirty: false,
                  data: book.data()
                }

                if(++successCount == array.length) {

                  // start

                  this.gridUpdating = true

                  for(i=(actionList.length-1);i>=0;i--) {
                    if(actionList[i].action == "rename") {
                      lastBookFrom = actionList[i].from
                      lastBookTo = actionList[i].to
                      break
                    }
                  }
                  // console.log(successCount)
                  // console.log(lastBookFrom)
                  // console.log(lastBookTo)
                  if(lastBookFrom == null && lastBookTo == null) {
                    if(actionList[0].id == 0) {
                      var saveLastBook = 0
                      var saveLastIndex = -1
                      var saveLastValues = null
                      var saveLastValuesModified = null
                    }
                    else {
                      var saveLastBook = actionList[0].id - 1
                      var saveLastIndex = 999
                      var saveLastValues = this.pageSensorHistory[saveLastBook].data[999]
                      var saveLastValuesModified = saveLastValues.t
                    }
                  }
                  else {
                    var saveLastBook = lastBookTo
                    if(lastBookFrom == endBook) {
                      var saveLastIndex = this.pageSensor.lastIndex
                      var saveLastValues = this.pageSensor.lastValues
                      var saveLastValuesModified = saveLastValues.t
                    }
                    else {
                      var saveLastIndex = 999
                      var saveLastValues = this.pageSensor.lastValues
                      var saveLastValuesModified = saveLastValues.t
                    }
                  }
                  // console.log(actionList)
                  // console.log(saveLastBook)
                  // console.log(saveLastIndex)
                  // console.log(saveLastValues)
                  // console.log(saveLastValuesModified)

                  // 이제 batch를 합시다.
                  // deleteList는 삭제함
                  // renameList는 update함
                  // bookInfo도 마찬가지로 편집함
                  // lastBook
                  // lastIndex
                  // lastValues

                  var batch = db.batch()
                  actionList.forEach(item => {
                    if(item.action == "delete") {
                      delete(this.pageSensor.bookInfo[item.id])
                      batch.delete(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item.id))
                    }
                    else if(item.action =="rename") {
                      this.pageSensor.bookInfo[item.to] = this.pageSensor.bookInfo[item.from]
                      batch.set(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item.to), this.pageSensorHistory[item.from].data)
                    }
                  })
                  saveLastBook = saveLastBook*1
                  endBook = endBook*1
                  saveLastIndex = saveLastIndex*1
                  for(var i=(saveLastBook*1+1);i<=endBook*1;i++) {
                    delete(this.pageSensor.bookInfo[i])
                    batch.delete(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(i+""))
                  }
                  batch.update(db.collection("sensors").doc(this.pageSensor.id), {
                    lastBook: saveLastBook*1,
                    lastIndex: saveLastIndex*1,
                    lastValues: saveLastValues,
                    bookInfo: this.pageSensor.bookInfo,
                    lastValuesModified: saveLastValuesModified,
                  })
                  batch.commit()
                  .then(() => {
                    actionList.forEach(item => {
                      if(item.action == "delete") {
                        delete(this.pageSensorHistory[item.id])
                      }
                      else if(item.action == "rename") {
                        this.pageSensorHistory[item.to] = this.pageSensorHistory[item.from]
                      }
                    })

                    for(var i=(saveLastBook*1+1);i<=endBook*1;i++) {
                      delete(this.pageSensorHistory[i])
                    }
                    //console.log(this.pageSensor.bookInfo)
                    //console.log(this.pageSensorHistory)
                    this.lastBook = this.pageSensor.lastBook
                    this.lastIndex = this.pageSensor.lastIndex
                    // this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()

                    this.deleteBooksSpinner = false;
                    this.gridUpdating = false;
                    this.makeToast("success", "데이터 묶음 삭제", "데이터 묶음을 삭제했습니다.")
                    this.hideModal('deleteBooks')
                  })
                  .catch(error => {
                    this.deleteBooksSpinner = false;
                    this.makeToast("danger", "데이터 묶음 삭제", "데이터 묶음 삭제 중에 에러가 발생했습니다. 에러 내용: " + error)
                    this.gridUpdating = false
                  })

                  // end
                }


              }
              else {
                if(item == 0) {
                  this.makeToast("danger", "데이터 삭제중", "데이터가 없습니다.")
                }
                else {
                  this.makeToast("danger", "데이터 삭제중", item + "번 묶음 데이터가 없습니다.")
                }
                return;
              }
            })
            .catch(error => {
              this.makeToast("danger", "데이터 삭제중", "데이터 삭제 중 에러가 발생했습니다. 에러 내용: " + error)
              return;
            })
          })
        }
        else {
          // start
          this.gridUpdating = true
          for(i=(actionList.length-1);i>=0;i--) {
            if(actionList[i].action == "rename") {
              lastBookFrom = actionList[i].from
              lastBookTo = actionList[i].to
              break
            }
          }
          // console.log(successCount)
          // console.log(lastBookFrom)
          // console.log(lastBookTo)
          if(lastBookFrom == null && lastBookTo == null) {
            if(actionList[0].id == 0) {
              var saveLastBook = 0
              var saveLastIndex = -1
              var saveLastValues = null
              var saveLastValuesModified = null
            }
            else {
              var saveLastBook = actionList[0].id - 1
              var saveLastIndex = 999
              var saveLastValues = this.pageSensorHistory[saveLastBook].data[999]
              var saveLastValuesModified = saveLastValues.t
            }
          }
          else {
            var saveLastBook = lastBookTo
            if(lastBookFrom == endBook) {
              var saveLastIndex = this.pageSensor.lastIndex
              var saveLastValues = this.pageSensor.lastValues
              var saveLastValuesModified = saveLastValues.t
            }
            else {
              var saveLastIndex = 999
              var saveLastValues = this.pageSensor.lastValues
              var saveLastValuesModified = saveLastValues.t
            }
          }
          // console.log(actionList)
          // console.log(saveLastBook)
          // console.log(saveLastIndex)
          // console.log(saveLastValues)
          // console.log(saveLastValuesModified)

          // 이제 batch를 합시다.
          // deleteList는 삭제함
          // renameList는 update함
          // bookInfo도 마찬가지로 편집함
          // lastBook
          // lastIndex
          // lastValues

          var batch = db.batch()
          actionList.forEach(item => {
            if(item.action == "delete") {
              delete(this.pageSensor.bookInfo[item.id])
              batch.delete(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item.id))
            }
            else if(item.action =="rename") {
              this.pageSensor.bookInfo[item.to] = this.pageSensor.bookInfo[item.from]
              batch.set(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item.to), this.pageSensorHistory[item.from].data)
            }
          })
          saveLastBook = saveLastBook*1
          endBook = endBook*1
          saveLastIndex = saveLastIndex*1
          for(var i=(saveLastBook*1+1);i<=endBook*1;i++) {
            delete(this.pageSensor.bookInfo[i])
            batch.delete(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(i+""))
          }
          batch.update(db.collection("sensors").doc(this.pageSensor.id), {
            lastBook: saveLastBook*1,
            lastIndex: saveLastIndex*1,
            lastValues: saveLastValues,
            bookInfo: this.pageSensor.bookInfo,
            lastValuesModified: saveLastValuesModified,
          })
          batch.commit()
          .then(() => {
            actionList.forEach(item => {
              if(item.action == "delete") {
                delete(this.pageSensorHistory[item.id])
              }
              else if(item.action == "rename") {
                this.pageSensorHistory[item.to] = this.pageSensorHistory[item.from]
              }
            })

            for(var i=(saveLastBook*1+1);i<=endBook*1;i++) {
              delete(this.pageSensorHistory[i])
            }
            // console.log(this.pageSensor.bookInfo)
            // console.log(this.pageSensorHistory)
            this.lastBook = this.pageSensor.lastBook
            this.lastIndex = this.pageSensor.lastIndex
            this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()

            this.makeToast("success", "데이터 묶음 삭제", "데이터 묶음을 삭제했습니다.")
            this.hideModal('deleteBooks')
            this.gridUpdating = false
          })
          .catch(error => {
            // console.log(error)
            this.makeToast("danger", "데이터 묶음 삭제", "데이터 삭제 중 에러가 발생했습니다. 에러 내용: " + error)
            this.gridUpdating = false
          })


          // end







        }


        if(oldActive) {
          db.collection("devices").doc(this.pageDevice.id).update({
            active: true
          })
        }

      }
    },
    closeDeleteBooks: function() {
      this.hideModal('deleteBooks')
    },

    openDeleteBooks: function() {
      this.showModal('deleteBooks');
    },

    applyProp: function(items) {
      this.selected = items
    },
  },
  computed: {
    selectedListObject: function() {
      var result = {}
      this.selected.forEach(item => {
        result[item.id] = true
      })
      return result
    },
    selectedList: function() {
      return this.selected.map(val => val.id).sort()
    },
    selectedListString: function() {
      return this.selected.map(val=> val.id).join(", ")
    },
    selectedTotalCount: function() {
      return this.selected.reduce((a,b)=>a + b.count, 0).toLocaleString()
    },
    rowCount: function() {
      return parseInt(this.lastBook)*1000 + parseInt(this.lastIndex) + 1
    },
    rowCountPageSensor: function() {
      return parseInt(this.pageSensor.lastBook)*1000 + parseInt(this.pageSensor.lastIndex) + 1
    },
    bookList: function() {
      var result = []
      // console.log(this.pageSensor.bookInfo);
      for(var book in this.pageSensor.bookInfo) {
        var item = {}
        item.id = book
        item.from = this.pageSensor.bookInfo[book].from
        item.to = this.pageSensor.bookInfo[book].to
        if(item.id == this.pageSensor.lastBook) {
            item.count = this.pageSensor.lastIndex + 1
        }
        else {
          item.count = 1000
        }
        result.push(item)
      }
      result.reverse()
      return result
    }
  },
}
</script>
<style>

.controlBlock { border-style: solid; border-color:#dee2e6; border-width: 1px 1px 0px 1px; font-family: 'Nanum Gothic', sans-serif; background-color: white; padding : 8px 8px 8px 20px;}

.bookGrid th { padding : 0.3rem 0.2rem 0.2rem 0.2rem; text-align: center; font-size: 0.9rem}
.bookGrid td { padding : 0.3rem 0.2rem 0.2rem 0.2rem; vertical-align: baseline;  font-size: 0.9rem}
.bookGrid td.numberTd { text-align : right; padding-right: 0.8rem; }
.bookGrid td.idTd { text-align : right; padding-right: 0.8rem; }
.bookGrid td.timeTd { text-align : center; padding-right: 0.8rem; }
.bookGrid td.selectTd { font-weight: bold; }
</style>
